import { API } from '../config/api';
import { WORK_STATION_RECORD_TYPES } from '../config/constants/workStationsConstants';
import { DataService } from '../config/dataService/dataService';

class WorkStationRecordsService {
  static WORK_STATION_IN_USE = 'WORK_STATION_IN_USE';

  static async getLastRecord() {
    const { data } = await DataService.get(API.workStationRecords.root, {
      pageSize: 1,
      page: 1,
      sortCreatedAt: -1,
      type: WORK_STATION_RECORD_TYPES.CHECK_IN.value,
    });
    return {
      workStationRecord: data.workStationRecords?.[0] ?? null,
    };
  }

  static async createRecord({ idWorkStation, idHeadquarter }) {
    const { data } = await DataService.post(`${API.workStationRecords.root}/${API.workStationRecords.checkIn}`, {
      idWorkStation,
      idHeadquarter,
    });
    return {
      workStationRecord: data.workStationRecord,
    };
  }

  static async expireRecord() {
    const { data } = await DataService.post(`${API.workStationRecords.root}/${API.workStationRecords.expire}`);
    return {
      workStationRecord: data.workStationRecord,
    };
  }
}

export { WorkStationRecordsService };
